'use client'
import classnames from 'classnames'
import React from 'react'
import Slider, {type ResponsiveObject} from 'react-slick'
import './styles.global.css'

type SliderProps = {
  prevArrow?: JSX.Element
  nextArrow?: JSX.Element
  infinite?: boolean
  responsive?: ResponsiveObject[]
  dotsOnTop?: boolean
  initialSlide?: number
  children: React.ReactNode
}

const TestimonialSlider: React.FC<SliderProps> = ({
  children,
  initialSlide = 0,
  prevArrow,
  nextArrow,
  infinite,
  responsive,
  dotsOnTop,
}) => {
  return (
    <Slider
      className={classnames(
        'testimonialSlider',
        'customSlider',
        dotsOnTop && 'dotsOnTop'
      )}
      initialSlide={initialSlide}
      dots
      infinite={infinite}
      responsive={responsive}
      arrows={!!prevArrow || !!nextArrow}
      swipe
      draggable
      touchMove
      speed={700}
      slidesToShow={1}
      slidesToScroll={1}
      focusOnSelect
      prevArrow={prevArrow}
      nextArrow={nextArrow}
    >
      {children}
    </Slider>
  )
}
export default TestimonialSlider
